module.exports = __webpack_public_path__ + "img/31.5d4e49b3.png";